import Volume from "@/src/_types/volume";

export const MapToVolumeItems = (data: any): Volume[] => {
    return data?.reduce((acc: Volume[], volume: Volume) => {
        if (!acc.some(v => v.volume_id === volume.volume_id)) {
            acc.push({ volume_id: volume.volume_id, volume_name: volume.volume_name });
        }
        return acc;
    }, []);
};
